export default "__VITE_ASSET__d2124ce5__"